import { render } from "./FoldersList.vue?vue&type=template&id=a5c4ece8&scoped=true"
import script from "./FoldersList.vue?vue&type=script&lang=js"
export * from "./FoldersList.vue?vue&type=script&lang=js"

import "./FoldersList.vue?vue&type=style&index=0&id=a5c4ece8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c4ece8"]])

export default __exports__